import { export_json_to_excelWithMultiSheet } from './excel/export2Excel'

async function testBtn(that, pathUrl) {
  var path = that.$route.path
  var list = []
  var obj = {
    editFlag: false,
    addFlag: false,
    removeFlag: false,
    upgradeFlag: false
  }
  await that.$get(that.url + that.hostAuth + '/dms/menu/findAll').then(res => {
    that.menuData = res.response.obj
    res.response.obj.forEach(res => {
      res.children.forEach(reschildren => {
        if (pathUrl == reschildren.resourcePath) {
          if (reschildren.children) {
            list = reschildren.children
          }
        } else if (reschildren.resourcePath == path) {
          if (reschildren.children) {
            list = reschildren.children
          }
        }
      })
    })
    list.forEach(res => {
      if (res.resourceName == "编辑" || res.resourceName == "修改") {
        obj.editFlag = true
      }
      else if (res.resourceName == "新增" || res.resourceName == "添加" || res.resourceName == "授权") {
        obj.addFlag = true
      }
      else if (res.resourceName == "删除") {
        obj.removeFlag = true
      } else if (res.resourceName == "转一级经销商") {
        obj.upgradeFlag = true
      } else if (res.resourceName == "同意") {
        obj.consentFlag = true
      } else if (res.resourceName == "驳回") {
        obj.unConsentFlag = true
      } else if (res.resourceName == "确认收货") {
        obj.receiptFlag = true
      } else if (res.resourceName == "查看") {
        obj.infoFlag = true
      } else if (res.resourceName == "回复") {
        obj.answerFlag = true
      } else if (res.resourceName == '过期导入') {
        obj.leadFlag = true
      } else if (res.resourceName == '导出') {
        obj.exportFlag = true
      } else if (res.resourceName == '代下单') {
        obj.agencyAddFlag = true
      }

    })
    obj = obj
  })
  return obj
}
function trim(str) {
  return str.replace(/(^\s*)|\s*$/g, '');
}
function selectMenu(keyPath) {
  var resourceName = ""
  JSON.parse(sessionStorage.menu).map((item, index) => {
    if (item.resourcePath == keyPath) {
      resourceName = item.resourceName;
      return
    } else {
      item.children.map((itemChild, indexChild) => {
        if (itemChild.resourcePath == keyPath) {
          resourceName = itemChild.resourceName;
          return
        }
      })
    }
  })
  return resourceName
  // menuData.map((item,index)=>{
  // 	if(item.resourcePath==keyPath[0]){
  // 		item.children.map((itemChild,indexChild)=>{
  // 			if(itemChild.resourcePath==key){
  // 				sessionStorage.menuRoute = itemChild.resourceName
  // 				return;
  // 			}
  // 		})
  // 	}
  // })
};
function downloadFile(res, fileName) {
  //   window.open(res)
  window.location.href = res
  //  let link = document.createElement('a')
  //     link.style.display = 'none'
  //     link.href = res
  //     link.setAttribute('download', fileName)// 文件名
  //     document.body.appendChild(link)
  //     link.click()
  //     document.body.removeChild(link) // 下载完成移除元素
  //   if (!res) {
  //     return
  //   }
  //   if (window.navigator.msSaveBlob) {  // IE以及IE内核的浏览器
  //     try {
  //       window.navigator.msSaveBlob(res, fileName)  // res为接口返回数据，这里请求的时候已经处理了，如果没处理需要在此之前自行处理var data = new Blob([res.data]) 注意这里需要是数组形式的,fileName就是下载之后的文件名
  //       // window.navigator.msSaveOrOpenBlob(res, fileName);  //此方法类似上面的方法，区别可自行百度
  //     } catch (e) {
  //       console.log(e)
  //     }
  //   } else {
  //     let url = window.URL.createObjectURL(new Blob([res]))
  //     let link = document.createElement('a')
  //     link.style.display = 'none'
  //     link.href = url
  //     link.setAttribute('download', fileName)// 文件名
  //     document.body.appendChild(link)
  //     link.click()
  //     document.body.removeChild(link) // 下载完成移除元素
  //     window.URL.revokeObjectURL(url) // 释放掉blob对象
  //   }
};
//格式转换，直接复制即可
function formatJson(filterVal, jsonData) {
  return jsonData.map(v => filterVal.map(j => v[j]))
};
/**
 * excel导出多sheet
 * @param sheetDataList sheetDataList  sheet数据数组 
 * 数据包含字段{
            dataName: this.titleColumns,
            dataList: this.totalRecords,
            statusList: ['正常', '停用'],
            spliceFlag: false,
            sheetName: "总计"
          }
 * @param excelName excelName excel名
 */
function export2ExcelWithMultiSheet(sheetDataList, excelName) {
  const multiHeader = []
  const multiData = []
  const sheetNameList = []

  for (let index = 0; index < sheetDataList.length; index++) {
    const sheetData = sheetDataList[index];
    var dataName = JSON.parse(JSON.stringify(sheetData.dataName));
    var dataList = JSON.parse(JSON.stringify(sheetData.dataList));
    var dataNameArr = [];
    var dataValArr = [];
    if (sheetData.spliceFlag) {
      dataName.splice(dataName.length - 1, 1)
    }
    dataName.map(item => {
      dataNameArr.push(item.title)
      dataValArr.push(item.dataIndex)
    })
    if (sheetData.statusList.length > 0) {
      dataList.map(item => {
        if (item.status == 0) {
          item.status = sheetData.statusList[0]
        } else if (item.status == 1) {
          item.status = sheetData.statusList[1]
        } else if (item.status == 2) {
          item.status = sheetData.statusList[2]
        }
        if (item.usedStatus == 0) {
          item.usedStatus = sheetData.statusList[0]
        } else if (item.usedStatus == 1) {
          item.usedStatus = sheetData.statusList[1]
        } else if (item.usedStatus == 2) {
          item.usedStatus = sheetData.statusList[2]
        }
      })
    }

    multiHeader.push(dataNameArr) // 导出的表头名信息
    multiData.push(formatJson(dataValArr, dataList))// 导出的表头字段名，需要导出表格字段名
    sheetNameList.push(sheetData.sheetName)
  }

  require.ensure([], () => {
    const { export_json_to_excelWithMultiSheet } = require('@/excel/export2Excel'); //这里必须使用绝对路径，使用@/+存放export2Excel的路径
    export_json_to_excelWithMultiSheet(multiHeader, multiData, excelName, sheetNameList);// 导出的表格名称，根据需要自己命名
  })
};
//数据写入excel
function export2Excel(dataName, dataList, statusList, excelName, spliceFlag) {

  var dataName = JSON.parse(JSON.stringify(dataName));
  var dataList = JSON.parse(JSON.stringify(dataList));
  var that = this;
  var dataNameArr = [];
  var dataValArr = [];
  if (spliceFlag) {
    dataName.splice(dataName.length - 1, 1)
  }
  dataName.map(item => {
    dataNameArr.push(item.title)
    dataValArr.push(item.dataIndex)
  })
  if (statusList.length > 0) {
    dataList.map(item => {
      if (item.status == 0) {
        item.status = statusList[0]
      } else if (item.status == 1) {
        item.status = statusList[1]
      } else if (item.status == 2) {
        item.status = statusList[2]
      }
      if (item.usedStatus == 0) {
        item.usedStatus = statusList[0]
      } else if (item.usedStatus == 1) {
        item.usedStatus = statusList[1]
      } else if (item.usedStatus == 2) {
        item.usedStatus = statusList[2]
      }
    })
  }
  require.ensure([], () => {
    const { export_json_to_excel } = require('@/excel/export2Excel'); //这里必须使用绝对路径，使用@/+存放export2Excel的路径
    const tHeader = dataNameArr; // 导出的表头名信息
    const filterVal = dataValArr; // 导出的表头字段名，需要导出表格字段名
    const list = dataList;
    const data = formatJson(filterVal, list);

    export_json_to_excel(tHeader, data, excelName);// 导出的表格名称，根据需要自己命名
  })
};
// tree转数组
function treeToArray(list, newArr = []) {
  const data = JSON.parse(JSON.stringify(list)) // 浅拷贝不改变源数据
  data.forEach((item) => {
    const { children } = item;
    if (children) {
      delete item.children;

      if (children.length) {
        newArr.push(item);
        return this.treeToArray(children, newArr);
      }
    }
    newArr.push(item);
  });
  return newArr;
};
//数组转tree
function filterArray(data, parent) {
  let vm = this;
  var tree = [];
  var temp;
  var arrPid = [];
  for (var i = 0; i < data.length; i++) {
    arrPid.push(data[i].id)
    if (data[i].pid == parent) {
      var obj = data[i];
      temp = filterArray(data, data[i].id);
      if (temp.length > 0) {
        obj.children = temp;
      }
      tree.push(obj);
    }
  }
  return tree;
}

function nowDate() {
  var now = new Date();
  var year = now.getFullYear(); //得到年份
  var month = now.getMonth();//得到月份
  var date = now.getDate();//得到日期
  var day = now.getDay();//得到周几
  var hour = now.getHours();//得到小时
  var minu = now.getMinutes();//得到分钟
  var sec = now.getSeconds();//得到秒
  var MS = now.getMilliseconds();//获取毫秒
  var week;
  month = month + 1;
  if (month < 10) month = "0" + month;
  if (date < 10) date = "0" + date;
  if (hour < 10) hour = "0" + hour;
  if (minu < 10) minu = "0" + minu;
  if (sec < 10) sec = "0" + sec;
  var arr_week = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");
  week = arr_week[day];
  var time = "";
  time = year + "." + month + "." + date + "-" + "" + hour + "：" + minu;
  return time
}
/**
 * 
 * @returns 获取当前年月,例2021-12
 */
function getCurrentYearAndMonth() {
  var now = new Date();
  var year = now.getFullYear(); //得到年份
  var month = now.getMonth() + 1;//得到月份
  if (month < 10) month = "0" + month;
  var yearAndMonth = "";
  yearAndMonth = year + "-" + month;
  return yearAndMonth
}
/**
* 
* @returns 获取当前年月-1,例2021-12---->2021-11
          6号之前向前减2个月---------->2021-10
*/
function getCurrentYearAndMonth_1() {
  var now = new Date();
  var year = now.getFullYear(); //得到年份
  var month = now.getMonth();//得到月份-1
  var day = now.getDate();
  var yearAndMonth = "";
  //console.log("日期",month);
  if (day < 6) {
    month = month - 1
  }
  if (month == 0) {
    return (year - 1) + "-12"
  }
  if (month == -1) {
    return (year - 1) + "-11"
  }
  if (month < 10) month = "0" + month;
  yearAndMonth = year + "-" + month;
  return yearAndMonth
}

// table高度
function tableHeight(){
  let height = 0
  height = document.documentElement.clientHeight - 350
  return height
}

export default {
  testBtn,
  selectMenu,
  trim,
  downloadFile,
  export2Excel,
  export2ExcelWithMultiSheet,
  treeToArray,
  nowDate,
  getCurrentYearAndMonth,
  getCurrentYearAndMonth_1,
  filterArray,
  tableHeight
}


// WEBPACK FOOTER //
// ./src/utils.js